// GeneralInfoValidation.js

/**
 * Validation utility for physician general information
 */
const GeneralInfoValidation = {
    /**
     * Validates physician general information form data
     * @param {Object} data - The form data to validate
     * @returns {Object} - Object containing fieldErrors and generalErrors
     */
    validateForm: (data) => {
        const fieldErrors = {};
        const generalErrors = [];
        
        // Field-specific validations
        if (!data.firstName || !data.firstName.trim()) {
            fieldErrors.firstName = 'First name is required';
        }
        
        if (!data.lastName || !data.lastName.trim()) {
            fieldErrors.lastName = 'Last name is required';
        }
        
        if (!data.dateOfBirth) {
            fieldErrors.dateOfBirth = 'Date of birth is required';
        }
        
        if (!data.gender) {
            fieldErrors.gender = 'Gender is required';
        }
        
        if (!data.lob) {
            fieldErrors.lob = 'Line of business is required';
        }
        
        if (!data.degrees || data.degrees.length === 0) {
            fieldErrors.degrees = 'At least one degree is required';
        }
        
        return {
            fieldErrors,
            generalErrors
        };
    },
    
    /**
     * Helper method to check if form is valid
     * @param {Object} data - The form data to validate
     * @returns {boolean} - True if valid, false otherwise
     */
    isValid: (data) => {
        const { fieldErrors, generalErrors } = GeneralInfoValidation.validateForm(data);
        return Object.keys(fieldErrors).length === 0 && generalErrors.length === 0;
    }
};

export default GeneralInfoValidation;